var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{'notVisible' : !_vm.isVisible},attrs:{"id":"header"}},[(_vm.isVisible)?_c('Menu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }